// extracted by css-extract-rspack-plugin
export default {"root":"root-t2UQYd","sectionHeader":"sectionHeader-nd_fh2","treemapRadioGroup":"treemapRadioGroup-pU6Si0"};